export class Projectmember {
    date_added?:string;
    fullname:string;
    im?:string;
    email?:string;
    phone?:string;
    personId:string;
    projectId:string;
    projectrole:string;
}